<template>
  <view class="radio-modal-cancel-btn-demo">
    <cube-radio-modal
      wx:ref="radioModal"
      title="关闭按钮配置"
      subtitle='你可以通过设置"cancelText"来显示关闭文案，同时将"cancelBtnAlign"设置为"right"'
      cancelText="关闭"
      cancelBtnAlign="right"
      options="{{ options }}"
      value="{{ checkedValue }}"
    />
    <cube-button bind:click="onTap">radio-modal-cancel-btn</cube-button>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      options: [
        {
          value: '1',
          text: '企业支付',
        },
        {
          value: '2',
          text: '亲友代付'
        },
        {
          value: '3',
          text: '个人支付'
        }
      ],
      checkedValue: '2'
    },
    methods: {
      onTap() {
        this.$refs.radioModal.show()
      }
    }
  })
</script>

<style lang="stylus">
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-radio-modal": "@mpxjs/mpx-cube-ui/src/components/radio-modal/index.mpx",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index.mpx"
    }
  }
</script>
